import React, { useCallback, useEffect, useState } from 'react';
import { RoundedButton } from './styled';
import { Box } from '@mui/material';
import { OptionalConcessionMaster } from './types';
import OptionalConcessionMasterTable from './components/OptionalConcessionMasterTable';
import OptionalConcessionMasterModal from './components/OptionalConcessionMasterModal';
import { PageWrapper, Title } from '../common/styled';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';
import optionalConcession from '../../apis/optionalConcession';

const OptionalConcessionMasterPage = () => {
  const [isOptionalConcessionModalOpen, setIsOptionalConcessionModalOpen] =
    useState<boolean>(false);

  const [isLoading, setIsLoading] = useState(false);

  const [optionalConcessionMasterData, setOptionalConcessionMasterData] =
    useState<OptionalConcessionMaster[]>([]);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const showToast = (message: string, severity: SnackbarSeverityType) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleOptionConcessionModalChange = () => {
    setIsOptionalConcessionModalOpen((prev) => {
      return !prev;
    });
  };

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  const fetchOptionalConcessionMaster = useCallback(async () => {
    const optionalConcessionData =
      await optionalConcession.getSchoolOptionalConcessionMaster(
        loggedInUser.school
      );
    setOptionalConcessionMasterData(
      optionalConcessionData as unknown as OptionalConcessionMaster[]
    );
  }, [loggedInUser.school]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await fetchOptionalConcessionMaster();

        showToast(
          'Optional Concession Master Fetched Successfully',
          SnackbarSeverityType.success
        );
      } catch (error: any) {
        showToast(
          error.errors?.[0].message ||
            'Error Fetching Optional Concession Master',
          SnackbarSeverityType.error
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [fetchOptionalConcessionMaster]);

  return (
    <Box>
      <Title
        style={{
          marginBottom: 25
        }}
      >
        Optional Concession Master
      </Title>
      <PageWrapper>
        <RoundedButton
          sx={{ alignSelf: 'flex-end' }}
          onClick={handleOptionConcessionModalChange}
        >
          Add
        </RoundedButton>
        <OptionalConcessionMasterTable
          OptionalConcessionMasterData={optionalConcessionMasterData}
          showToast={showToast}
          isLoading={isLoading}
          fetchOptionalConcessionMaster={fetchOptionalConcessionMaster}
        />
      </PageWrapper>
      <OptionalConcessionMasterModal
        isOptionalConcessionModalOpen={isOptionalConcessionModalOpen}
        heading={'Add Concession'}
        buttonTitle={'Save'}
        mode='add'
        fetchOptionalConcessionMaster={fetchOptionalConcessionMaster}
        onClose={handleOptionConcessionModalChange}
        showToast={showToast}
      />
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </Box>
  );
};

export default OptionalConcessionMasterPage;
